import React from "react";
import Rectangle from "../components/rectangle";

export function generateRectangleField(objects, data) {
  var amount = 1;
  objects.forEach((object) => {
    if (
      object["fieldProperties"] &&
      object["fieldProperties"]["fieldType"] == "rectangle"
    ) {
      amount += 1;
    }
  });

  return {
    objectType: "field",
    name: "ValueFromRectangle" + amount,
    fieldProperties: {
      fieldType: "rectangle",
      rectangle: [
        data["topLeftCornerX"],
        data["topLeftCornerY"],
        data["width"],
        data["height"],
      ],
      pageIndex: data["page"],
    },
  };
}

export function generateRectangleFromDetectedField(data) {
  return {
    objectId: data.objectId,
    objectType: "field",
    name: data.altFieldName,
    fieldProperties: {
      fieldType: "rectangle",
      rectangle: [
        data["left"],
        data["top"],
        data["width"],
        data["height"],
      ],
      pageIndex: data["pages"],
    },
    data: data
  };
}

export function generateRectangleFromProjectObject(data) {
  return {
    objectId: data.objectId,
    objectType: "field",
    name: "",
    fieldProperties: {
      fieldType: "rectangle",
      rectangle: [
        data["x"],
        data["y"],
        data["width"],
        data["height"],
      ],
      pageIndex: data["pages"],
    },
    data: data
  };
}

